import type { FC } from "react";

import { Views } from "../Views";

export const DocIndex: FC<{ onClick: Function }> = ({ onClick }) => {
    return (
        <ul>
            <li>
                <button type="button" onClick={() => onClick(Views.COLORS)}>
                    Colors
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.TYPOGRAPHY)}>
                    Typography
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.FORMS)}>
                    Forms
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.INPUTS)}>
                    Inputs
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.BUTTONS)}>
                    Buttons
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.FORM_FIELDS)}>
                    Form Fields
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.TABLES)}>
                    Tables
                </button>
            </li>
            <li>
                <button type="button" onClick={() => onClick(Views.FORM_PAGE)}>
                    Form Page
                </button>
            </li>
        </ul>
    );
};
